import {createInjectionState, useEventBus} from '@vueuse/core'

const [useProvideAppContentAnimation, useAppContentAnimation] = createInjectionState(() => {
  const animationBus = useEventBus<null>(null)

  return {
    animationBus,
  }
})

export {useProvideAppContentAnimation, useAppContentAnimation}
